/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { setStepDetails } from "src/redux/Actions/common";
// import * as yup from "yup";
import { setJointCovidAndNriDetails } from "src/redux/Thunk";
// import regex from "src/helpers/regex";
// import CustomCheckBox from "src/shared/CustomCheckBox";
import store from "src/redux/store";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import {
  withNriValidationSchema,
  withoutNriValidationSchema
} from "src/helpers/FormDetails/ProposalDetails/CovidAndNri";
import CustomModal from "src/shared/CustomModal";
import { useState } from "react";
// import CovidForm from "../../ProposerDetails/Covid&NRI/CovidForm";
// import CovidVaccine from "../../ProposerDetails/Covid&NRI/CovidVaccine";
import NRIDetails from "../../ProposerDetails/Covid&NRI/NRIDetails";
import TravelDetails from "../../ProposerDetails/Covid&NRI/TravelDetails";
import OccupationDetails from "../../ProposerDetails/Covid&NRI/OccupationDetails";
import SalaryDetails from "../../ProposerDetails/Covid&NRI/SalaryDetails";
import SelfEmployeedDetails from "../../ProposerDetails/Covid&NRI/SelfEmployeedDetails";
import BankDetails from "../../ProposerDetails/Covid&NRI/BankDetails";
import AddressDetails from "../../ProposerDetails/Covid&NRI/AddressDetails";
import InsuranceDetails from "../../ProposerDetails/Covid&NRI/InsuranceDetails";

// interface Props {
//   setStepNo: any;
//   setParentStepNo: any;
// }

function JointLifeCovidAndNri() {
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const covidAndNriDetails = useAppSelector(
    (state: any) => state.jointLifeAddendum.covidAndNriDetails
  );
  // const leadId = useAppSelector((state) => state.common.leadId);
  // const tableData = useAppSelector((state) => state.dashboard.tableData);
  const proposalStatus = useAppSelector((state) => state.proposalStatus.status);
  const nationality = useAppSelector((state) => state.jointLifeAddendum?.member?.nationalityCode);
  const jointStepNo = useAppSelector((state) => state.stepDetails?.jointStepNo);
  const parentStepNo = useAppSelector((state) => state.stepDetails?.parentStepNo);
  const jointDoB = useAppSelector((state) => state.jointLifeAddendum?.member?.dob) || "";

  // const isJointAddendumState = useSelector((state: any) => state.isJointAddendum);

  const getInitialValues = () => {
    const intialObj = {
      covidTest: {
        covidPositive: covidAndNriDetails.covidTest.covidPositive,
        covidQuarantine: covidAndNriDetails.covidTest.covidQuarantine || "",
        covidComplication: covidAndNriDetails.covidTest.covidComplication || ""
      },
      covidVaccineDates: {
        covidVaccinated: covidAndNriDetails.covidVaccineDates.covidVaccinated,
        dateOfFirstDose: covidAndNriDetails.covidVaccineDates.dateOfFirstDose || "",
        dateOfSecondDose: covidAndNriDetails.covidVaccineDates.dateOfSecondDose || "",
        dateOfBoosterDose: covidAndNriDetails.covidVaccineDates.dateOfBoosterDose || ""
      },
      ...(nationality !== "RES" && {
        nriDetails: {
          currentCountry: covidAndNriDetails.nriDetails.currentCountry || "",
          currentCountryCode: covidAndNriDetails.nriDetails.currentCountryCode || "",
          cityOfResidence: covidAndNriDetails.nriDetails.cityOfResidence || "",
          lastDateOfEntryToIn: covidAndNriDetails.nriDetails.lastDateOfEntryToIn || "",
          exitDateFromIndia: covidAndNriDetails.nriDetails.exitDateFromIndia || "",
          durationOfStayAbroad: covidAndNriDetails.nriDetails.durationOfStayAbroad || "",
          purposeOfStayAbroad: covidAndNriDetails.nriDetails.purposeOfStayAbroad || "",
          insurancePurpose: covidAndNriDetails.nriDetails.insurancePurpose || ""
        },
        otherCountryTravel: {
          isOtherCountryTravel: covidAndNriDetails.otherCountryTravel.isOtherCountryTravel,
          countryName: covidAndNriDetails.otherCountryTravel.countryName || "",
          countryNameCode: covidAndNriDetails.otherCountryTravel.countryNameCode || "",
          duration: covidAndNriDetails.otherCountryTravel.duration || "",
          purpose: covidAndNriDetails.otherCountryTravel.purpose || ""
        },
        occupationDetails: {
          occupationNameAndRole: covidAndNriDetails.occupationDetails.occupationNameAndRole || ""
        },
        salaried: {
          isSalaried: covidAndNriDetails.salaried.isSalaried,
          companyName: covidAndNriDetails.salaried.companyName || "",
          designation: covidAndNriDetails.salaried.designation || "",
          currency: covidAndNriDetails.salaried.currency || "Rupee",
          monthlyIncome: covidAndNriDetails.salaried.monthlyIncome || ""
        },
        selfEmployed: {
          isSelfEmployed: covidAndNriDetails.selfEmployed.isSelfEmployed,
          grossTurnover: covidAndNriDetails.selfEmployed.grossTurnover || "",
          annualIncome: covidAndNriDetails.selfEmployed.annualIncome || ""
        },
        bankDetails: {
          nameOfTheBank: covidAndNriDetails.bankDetails.nameOfTheBank || "",
          branch: covidAndNriDetails.bankDetails.branch || "",
          accountNumber: covidAndNriDetails.bankDetails.accountNumber || ""
        },
        residence: {
          nameOfTheBankResidence: covidAndNriDetails.residence.nameOfTheBankResidence || ""
        },
        policyDetails: {
          isOtherPolicyOutsideIndia: covidAndNriDetails.policyDetails.isOtherPolicyOutsideIndia,
          insurerName: covidAndNriDetails.policyDetails.insurerName || "",
          sumAssured: covidAndNriDetails.policyDetails.sumAssured || "",
          premiumAccount: covidAndNriDetails.policyDetails.premiumAccount || "",
          policyStatus: covidAndNriDetails.policyDetails.policyStatus || "",
          dateOfInsurance: covidAndNriDetails.policyDetails.dateOfInsurance || ""
        },
        addJoint: {
          isJoint: false
        }
      })
    };

    return intialObj;
  };

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: getInitialValues(),
    validationSchema:
      nationality === "RES" ? withoutNriValidationSchema() : withNriValidationSchema(jointDoB!),
    onSubmit: async (fieldValues) => {
      // setParentStepNo(3);
      // dispatch(setStepDetails({ parentStepNo: 3 }));
      if (proposalStatus !== "MEF Submitted") {
        store.dispatch(setJointCovidAndNriDetails(fieldValues, { parentStepNo: parentStepNo + 1 }));
        window.scrollTo(0, 0);
      }
    }
  });
  const handleProposerCovidNriForm = () => {
    if (!formik.isValid) setModalOpen(true);
    formik.handleSubmit();
  };

  // const handleChange = (field: any) => (evt: any) => {
  //   dispatch(setCovidAndNriDetails({ field, value: evt.target.value }));
  // };
  // console.log("formik.values", formik.values, formik.errors, formik.touched);
  return (
    <>
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      <div className="px-10 mt-8">
        {/* Commented out the COVID section as it's no longer needed but can be reused if required. */}
        {/* <p className="font-montserrat text-base text-black font-bold mb-6">Covid Details</p>
        <CovidForm formik={formik} />
        <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
        <CovidVaccine formik={formik} />
        <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" /> */}
        {nationality !== "RES" && (
          <div>
            <NRIDetails formik={formik} dob={jointDoB} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <TravelDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <OccupationDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <SalaryDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <SelfEmployeedDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <BankDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <AddressDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <InsuranceDetails formik={formik} dob={jointDoB} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
          </div>
        )}
        {/* <div>
      <CustomCheckBox
        label="Add Joint Life Addendum"
        name="existingPolicy.existingLifeCover"
        handleBlur={formik.handleBlur}
        setFieldValue={formik.setFieldValue}
      />
    </div> */}
        <div className="flex items-center justify-center">
          <Button
            onClick={() => {
              dispatch(setStepDetails({ jointStepNo: jointStepNo - 1 }));
              window.scrollTo(0, 0);
            }}
            variant="outlined"
            classes={{ outlined: "!rounded-lg" }}
            className="!text-black !uppercase h-13 w-37.5 rounded-lg !mr-10"
          >
            Back
          </Button>
          <Button
            onClick={handleProposerCovidNriForm}
            variant="contained"
            classes={{ contained: "!rounded-lg" }}
            className="!uppercase h-13 w-37.5 rounded-lg"
          >
            Next
          </Button>
        </div>
      </div>
    </>
  );
}

export default JointLifeCovidAndNri;
